import $ from 'jquery'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Select from 'ol/interaction/Select'
import { parseStyle } from '../styleParser'
import { click, never } from 'ol/events/condition'
import Feature from 'ol/Feature'
export default function FeatureSelection(config) {
  $.extend(this, config)
  this.active = false

  this.featureOverlayLayer = new VectorLayer({
    source: new VectorSource({
      useSpatialIndex: false
    }),
    updateWhileAnimating: true,
    updateWhileInteracting: true
  })
}
FeatureSelection.prototype.highlightFeature = function(f) {
  f.setStyle(this.style)
}
FeatureSelection.prototype.getFeatures = function() {
  return this.featureOverlayLayer.getSource().getFeaturesCollection()
}

FeatureSelection.prototype.addFeature = function(f) {
  const feature = f.clone()
  this.featureOverlayLayer.getSource().addFeature(feature)
  this.highlightFeature(feature)
}
FeatureSelection.prototype.clearFeatures = function() {
  this.featureOverlayLayer.getSource().clear()
}
FeatureSelection.prototype.activate = function() {
  if (!this.active) {
    this.featureOverlayLayer.setMap(this.map)
    this.active = true
  }
}
FeatureSelection.prototype.deactivate = function() {
  if (this.active) {
    this.featureOverlayLayer.setMap(null)
    this.active = false
  }
}
